/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".webp[_ngcontent-%COMP%]   .bg-cover[_ngcontent-%COMP%]   .bg-dark[_ngcontent-%COMP%]   .bg-size--cover[_ngcontent-%COMP%]{background-image:url(realestate-image-editing-from-Imageingine.ad66b65d5cfbdbe4ef2b.webp)}.no-webp[_ngcontent-%COMP%]   .bg-cover[_ngcontent-%COMP%]   .bg-dark[_ngcontent-%COMP%]   .bg-size--cover[_ngcontent-%COMP%]{background-image:url(realestate-image-editing-from-Imageingine.e7386996121f449d3bec.jpg)}\n/*# sourceMappingURL=home.component.css.map*/"];
export { styles as styles };
